export enum MappingDataQualityTypesEnum {
  FULL_OVERLAP = 'full overlap',
  PARTIAL_OVERLAP = 'partial overlap',
  NO_OVERLAP = 'no overlap'
}
